import { Grid, Icon, Toolbar, Tooltip } from "@mui/material";
import CoreIconButton from "../../inputs/CoreIconButton";
import { theme } from "../../../config/theme";
import CoreTypographyBody1 from "../CoreTypographyBody1";
import { alpha } from "@mui/material/styles";
import CoreInput from "../../inputs/CoreInput";

export function CoreDataTableToolbar(props) {
  const {
    selections,
    rowActions,
    actions,
    searchable,
    searchStr,
    onSearchChange,
    getData,
  } = props;
  const numSelected = selections?.length;
  const { func, page, rowsPerPage } = getData;

  const searchData = (e) => {
    e?.preventDefault();
    console.log("here ", searchStr);
    func(page, rowsPerPage, true, searchStr);
  };

  // console.log(selections, rowActions, actions);

  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.3),
        },
      ]}
      style={{
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius,
        display: "flex",
        justifyContent: numSelected === 0 ? "flex-end" : "space-between",
        alignItems: "center",
      }}
    >
      {numSelected > 0 ? (
        <CoreTypographyBody1 style={{ textAlign: "center" }}>
          {numSelected} selected
        </CoreTypographyBody1>
      ) : null}
      {numSelected > 0 ? (
        rowActions
          .filter((action) => action.bulk)
          .map((action) =>
            action?.title ? (
              <CoreIconButton
                onClick={() => {
                  action.onClick(selections);
                }}
              >
                <Tooltip title={action?.title}>
                  <Icon>{action.icon}</Icon>
                </Tooltip>
              </CoreIconButton>
            ) : (
              <CoreIconButton
                onClick={() => {
                  action.onClick(selections);
                }}
              >
                <Icon>{action.icon}</Icon>
              </CoreIconButton>
            ),
          )
      ) : searchable ? (
        <Grid container>
          <Grid item xs={12} sm={3}>
            <form onSubmit={searchData}>
              <CoreInput
                label="Search here"
                value={searchStr}
                onChange={onSearchChange}
                endAdornment={
                  searchStr &&
                  searchStr?.length > 0 && (
                    <>
                      <CoreIconButton
                        size="small"
                        onClick={() => {
                          onSearchChange({ target: { value: "" } });
                          func(page, rowsPerPage, true, "");
                        }}
                      >
                        <Icon>cancel</Icon>
                      </CoreIconButton>
                      <CoreIconButton size="small" onClick={searchData}>
                        <Icon>search</Icon>
                      </CoreIconButton>
                    </>
                  )
                }
              />
            </form>
          </Grid>
        </Grid>
      ) : null}
      {numSelected < 1 &&
        actions?.map((action) =>
          action?.title ? (
            <CoreIconButton onClick={action.onClick}>
              <Tooltip title={action?.title}>
                <Icon>{action.icon}</Icon>
              </Tooltip>
            </CoreIconButton>
          ) : (
            <CoreIconButton onClick={action.onClick}>
              <Icon>{action.icon}</Icon>
            </CoreIconButton>
          ),
        )}
    </Toolbar>
  );
}
